import Feedback from './feedback'
import DataProcessor from './data-processor'
import Validator from './validator'

export default {
  mixins: [Feedback, DataProcessor, Validator]
}



// WEBPACK FOOTER //
// ./src/mixins/common.js